<template>
  <div class="base-info">
    <el-row :gutter="20">
      <el-col
        :span="val.span ? val.span : 24"
        v-for="val in dataList"
        :key="val.key"
      >
        <div class="flex-start-start">
          <div class="label">{{ val.value && val.value + '：' }}</div>
          <div class="flex_1">
            <slot v-if="val.isSlot" :row="baseInfo[val.key]"></slot
            >{{ val.isSlot ? '' : baseInfo[val.key] || '-' }}
          </div>
        </div>
      </el-col>
    </el-row>
    <!-- <div class="flex-start-start" v-for="val in dataList" :key="val.key">
      <div :span="2" class="label">{{ val.value && val.value + '：' }}</div>
      <div :span="20" class="flex_1">
        <slot v-if="val.isSlot" :row="baseInfo[val.key]"></slot
        >{{ val.isSlot ? '' : baseInfo[val.key] || '-' }}
      </div>
    </div> -->
  </div>
</template>

<script>
/**
 * @author xingzhesun
 * @name   baseInfo
 * @desc   健康管理-随访计划-基本信息
 * @props  none
 * @emit   none
 */
export default {
  props: {
    baseInfo: {
      type: Object,
    },
    dataList: {
      type: Array,
    },
  },
  data() {
    return {}
  },
}
</script>

<style lang="scss" scoped>
.base-info {
  .flex-start-start {
    margin-top: 20px;
    color: #333;
    align-items: flex-start;
    /* .label {
      width: 100px;
      text-align: right;
    } */
  }
}
</style>
